export class CloseError extends Error {}
